module.exports = __webpack_public_path__ + "static/img/hand.4cc7afa7.gif";